import { render } from "./appheaderMain.vue?vue&type=template&id=66fc96f0&scoped=true"
import script from "./appheaderMain.vue?vue&type=script&lang=js"
export * from "./appheaderMain.vue?vue&type=script&lang=js"

import "./appheaderMain.vue?vue&type=style&index=0&id=66fc96f0&lang=scss&scoped=true"

import exportComponent from "/Users/vee/Desktop/git/web/bitcoooPcWebsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fc96f0"]])

export default __exports__